module.exports = __webpack_public_path__ + "img/couponclass7rc1.66f95362.png";